module.exports = __webpack_public_path__ + "d3272691bcd05aecf5d3028edcd6d8b3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/spiky-hair-s.png
// module id = 2330
// module chunks = 0